module.exports = new __parcel__URL__("chemical-lg.3c442c8d.jpg").toString();